export default "__VITE_ASSET__BIIaXUVC__"